import React from "react";
import { motion } from "framer-motion";
import ProductCard from "./components/ProductCard";
import FooterSection from "./components/landing/FooterSection";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Stagger each child by 0.2 seconds
    },
  },
};

const MainScreen = ({ products, navigate, addingToCart, setAddingToCart, handleAddToCart }) => {
  return (
    <div>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-2 bg-primary dark:bg-primary-dark md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl mx-auto py-14"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            setSelectedProduct={(product) => navigate(`/product/${product.id}`)}
            addingToCart={addingToCart}
            setAddingToCart={setAddingToCart}
            handleAddToCart={handleAddToCart}
          />
        ))}
      </motion.div>
      <FooterSection />
    </div>
  );
};

export default MainScreen;